<template>
  <Transition name="slide">
    <div v-if="updateAvailable" class="update-bar">
      <div class="update-content">
        <Button @click="refreshApp" severity="secondary">
          A new version is available, Update Now
        </Button>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import Button from './Button.vue';

const updateAvailable = ref(false);
const currentVersion = import.meta.env.VITE_APP_VERSION;

const checkVersion = async () => {
  try {
    const res = await fetch(`/version.json?t=${Date.now()}`);
    const data = await res.json();

    if (data.version && data.version !== currentVersion) {
      updateAvailable.value = true;
    }
  // eslint-disable-next-line no-empty
  } catch {}
};

const refreshApp = () => {
  // Force reload from server, clearing local cache
  window.location.reload();
};

onMounted(() => {
  // Initial check after 5s, then every 15 mins
  setTimeout(checkVersion, 5000);
  setInterval(checkVersion, 1000 * 60 * 15);
});
</script>

<style scoped>
.update-bar {
  left: 0;
  padding: 12px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;
}

.update-content {
  align-items: center;
  display: flex;
  justify-content: center;
}

/* Slide Transition */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.4s ease;
}
.slide-enter-from, .slide-leave-to {
  transform: translateY(-100%);
}
</style>
